import { Center, Loader, Stack, Text } from "@mantine/core";

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message }: LoadingScreenProps) {
  return (
    <Center h="100dvh">
      <Stack align="center" gap="md">
        <Loader size="lg" color="indigo" />
        {message && (
          <Text size="sm" c="dimmed">
            {message}
          </Text>
        )}
      </Stack>
    </Center>
  );
}
